import React from 'react';
import { CalendarDaysIcon, ClipboardListIcon, ShieldIcon, UsersIcon, CheckIcon } from 'lucide-react';
const stats = [[CalendarDaysIcon, '365', 'Days of curriculum'], [ClipboardListIcon, '6', 'Coaching modules'], [UsersIcon, 'All', 'Age groups'], [ShieldIcon, 'Full', 'Game coverage']] as const;
const tags = ['Attack', 'Defense', 'Set Pieces', 'Scrum / Lineout', 'Tactical Kicking', 'Physical Preparation', 'Leadership', 'Match Day'];
export function SystemSection() {
  return <section className="border-y-4 border-[#d4af37] bg-[#16161F] px-5 py-20" data-id="element-225" data-mp="2wt78g4ruzbsw">
      <div className="mx-auto max-w-6xl text-center" data-id="element-226" data-mp="2srm10yy3fpq3">
        <p className="inline-block bg-[#d4af37] px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#0A0A0A]" data-id="element-227" data-mp="2sqaz74o7ks1m">
          The complete system to stop improvising training
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-228" data-mp="2itg30sfer3qi">
          Rugby <span className="text-[#d4af37]" data-id="element-229" data-mp="2dxh6uinu8hfj">Ready</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base font-medium leading-relaxed text-[#B0B0C0]" data-id="element-230" data-mp="13xn4jo9t3bu6">
          365 days of structured sessions. Attack, defense, set pieces, tactical
          kicking, physical preparation and team leadership.{' '}
          <strong className="text-white" data-id="element-231" data-mp="yzvdewgzjtr1">Everything ready.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-232" data-mp="yxscvii7ii82">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-[#d4af37]/25 bg-[#0A0A0A] p-6" data-id="element-233" data-mp="1roisgab55mw5">
              <Icon className="mx-auto h-7 w-7 text-[#d4af37]" data-id="element-234" data-mp="1cqi0frddvv7a" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-235" data-mp="1hqml7tlbrc3b">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-236" data-mp="1buxvv31cv0v">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-[#d4af37]/25 bg-[#0A0A0A] p-7" data-id="element-237" data-mp="28y4u6hxpej1w">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-238" data-mp="2907j0yn4e651">
            Full coverage, every category
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-239" data-mp="1z81phkh7zgnq">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-[#d4af37]/25 bg-[#16161F] px-3 py-2 text-xs font-bold text-white" data-id="element-240" data-mp="1u9qkbn1vdubu">
                <CheckIcon className="h-3.5 w-3.5 text-[#d4af37]" data-id="element-241" data-mp="1l80sig42stdj" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}